import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,InputNumber,Input, Col, Row, Select, DatePicker, AutoComplete, Cascader,Button,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import '../../assets/css/App.css';
import Header1 from '../public';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;
const InputGroup = Input.Group;
const Option = Select.Option;



class LDEval extends React.Component{
    constructor(props){
        super(props);
        this.state={
          calFlag:false,
          initcalFlag:false,
          Dr:0,
          Cp:0.5,
          Nc:0,
          Up:0.33,
          Score:0,
          color:"#fff",
          median:"12.6 months, and the cumulative 1-, 2-, and 3-year progression-free rates were 50.7%, 25.5%, and 9.4%, respectively."
        }
    }
   

    handleChangePrecentage= (value) => {
      if(value==100)
      {  this.setState({Dr:0}) }
      else if((value>85)&&(value<=99))
      {  this.setState({Dr:0.33}) }
      else if((value>35)&&(value<=85))
      {  this.setState({Dr:0.66}) }
      else
      {  this.setState({Dr:0.99}) }

      this.setState({
        calFlag:false,
      });
    }
    handleChangecompact = (value) => {
      this.setState({
        Cp:value,
        calFlag:false,
      });
    }
    handleChangenecrosis= (value) => {
      this.setState({
        Nc:value,
        calFlag:false,
      });
    }
    handleChangepattern= (value) => {
      this.setState({
        Up:value,
        calFlag:false,
      });
    }
    onClick=()=>{
      this.setState({
        initcalFlag:true,
        calFlag:true,
        
      });
      this.state.Score=this.state.Dr*this.state.Cp*this.state.Up*this.state.Nc;
      console.log(this.state.Dr,this.state.Cp,this.state.Nc,this.state.Up)
      this.state.Score=(-this.state.Score);
      if(this.state.Score>=-0.054)
      {  
        this.state.color="rgb(158,248,176)" 
        this.state.median="12.6 months, and the cumulative 1-, 2-, and 3-year progression-free rates are 50.7%, 25.5%, and 9.4%, respectively."
      }
      else if((this.state.Score<-0.054)&&(this.state.Score>=-0.165))
      {  
        this.state.color="rgb(196,230,242)" 
        this.state.median="7.2 months, and the cumulative 1-, 2-, and 3-year progression-free rates are 32.4%, 12.2%, and 4.8%, respectively."
      }
      else
      {  
        this.state.color="rgb(255,206,206)" 
        this.state.median="3.4 months, and the cumulative 1-, 2-, and 3-year progression-free rates are 14.3%, 5.2%, and 2.1%, respectively."
      }

    }
    render(){
      let onShow;
      if((this.state.calFlag)&&(this.state.initcalFlag))
      {
          onShow=(
            <div className="onShowNomo">
            <br></br>
            <txt style={{marginLeft:50, fontSize:30,width:"100%"}}>The result of lipiodol deposition is: <txt style={{color:this.state.color}}>exp({this.state.Score})</txt></txt>
            <br></br>
            <txt style={{marginLeft:50, fontSize:30,width:"100%"}}>Median time to progression of this LD is : {this.state.median}</txt>
            <br></br>
            <br></br>

            <img src={require('../../assets/images/Fig2.jpg')} alt=""  style={{width:"100%"}} />
            </div>
          )
          
      }
      else if(this.state.initcalFlag){
          onShow=(
              <div className="onShowNomo" style={{opacity:0.2}}>
              <br></br>
              <txt style={{marginLeft:50, fontSize:30,width:"100%"}}>The result of lipiodol deposition is: <txt style={{color:this.state.color}}>exp({this.state.Score})</txt></txt>
              <br></br>
              <txt style={{marginLeft:50, fontSize:30,width:"100%"}}>Median time to progression of this LD is : {this.state.median}</txt>
              <br></br>
              <br></br>
              <img src={require('../../assets/images/Fig2.jpg')} alt=""  style={{ width:"100%" }} />

              </div>
          )
      }

        return(
            <div>
                <div>
                  <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{ background: '#fff' }}>
              <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['2']}
                    defaultOpenKeys={['sub3']}
                    style={{ height: '100%' }}
                  >
                    <SubMenu key="sub3" title={<span><Icon type="user" />Lipiodol</span>}>
                      <Menu.Item key="1"><Link to="/hcc-ld-introduction">Introduction</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/hcc-ld-evaluation">Evaluation</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub4" title={<span><Icon type="user" />Prediction</span>}>
                      <Menu.Item key="5"><Link to="/hcc-cal-introduction">Introduction</Link></Menu.Item>
                      <Menu.Item key="6"><Link to="/hcc-cal-calculation">Calculation</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                <Content>  
                  <div style={{marginLeft:50}}>
                    <div style={{ marginLeft: 50 }}>
                      <txt style={{ fontSize: 20, fontWeight: 'bold' }}>LD Precentage (Dr): </txt>
                      <InputNumber
                        defaultValue={100}
                        size="large"
                        min={0}
                        max={100}
                        formatter={value => `${value}%`}
                        parser={value => value.replace('%', '')}
                        onChange={this.handleChangePrecentage}
                      />

                      <txt style={{ paddingLeft: 60, fontSize: 20, fontWeight: 'bold' }}>LD compact (Cp): </txt>
                        <Select defaultValue={0.5} onChange={this.handleChangecompact}>
                          <Option value={0.5}>Compact</Option>
                          <Option value={1}>Other</Option>
                        </Select>

                        
                      <txt style={{ paddingLeft: 60, fontSize: 20, fontWeight: 'bold' }}>LD necrosis (Nc): </txt>
                        <Select defaultValue={0} onChange={this.handleChangenecrosis}>
                          <Option value={0}>100%</Option>
                          <Option value={0.5}>50~99%</Option>
                          <Option value={1}>Other</Option>
                        </Select>

  
                      <txt style={{ paddingLeft: 60, fontSize: 20, fontWeight: 'bold' }}>LD pattern (Up): </txt>
                        <Select defaultValue={0.33} onChange={this.handleChangepattern}>
                          <Option value={0.33}>nodule uptake</Option>
                          <Option value={0.5}>multinodular uptake</Option>
                          <Option value={1}>other</Option>
                        </Select>

                        <Button type="primary" shape="round" size="large" style={{ marginLeft: 60, marginTop: 50, background: 'rgb(147, 197, 163)' }} onClick={this.onClick}>Calculate</Button>
                     
                    </div>

                  </div>
                  <Content>  
                    <div style={{marginTop:50 }}>{onShow}</div>

                    </Content>  
                    </Content>  
              </Layout>
            </Content>
            </div>
            </div>
        )
    }
}
export default LDEval;